import { FeatureFlagProfile } from "src/app/shared/models/featureFlagProfile";

export interface FeatureFlagsState {
    profile: FeatureFlagProfile ;
}

export const initialState: FeatureFlagsState = {
    profile: null,
};